import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { CacheService, IAreaTerritorialBO } from '@mapfre-tech/amap3';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class TerritorialAreaService {

  className = 'TerritorialAreaService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllAreas(cache = true, cacheKey = "allTerritorialAreas"): Observable<IAreaTerritorialBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IAreaTerritorialBO[]>;
    } else {
      const observable = this.http.get<IAreaTerritorialBO[]>(environment.base_URL + "/territorial-area").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newArea(area: IAreaTerritorialBO): Observable<IAreaTerritorialBO> {
    return this.http.post<IAreaTerritorialBO>(environment.base_URL + "/territorial-area", area).pipe(tap(() => this.deleteCache()))
  }

  updateArea(area: IAreaTerritorialBO, id: number): Observable<IAreaTerritorialBO> {
    return this.http.put<IAreaTerritorialBO>(environment.base_URL + `/territorial-area/${id}`, area).pipe(tap(() => this.deleteCache()))
  }

  deleteCache() {
    this.cacheService.deleteCache('allTerritorialAreas');
  }
}
